import type { OpenAPI } from "simplydo/interfaces";

/** Organisation from getByCode / urlOrganisation store — includes resolved logo URLs at runtime. */
export type UrlOrganisation =
  OpenAPI.GET<"/organisations/code/{code}">["response"];

export type LoginResponse = OpenAPI.POST<"/accounts/login">["response"];

export type MagicLoginEmailResponse = {
  securityPhrase: string;
  exchangeToken: string;
};

export function isMagicLoginEmailResponse(
  data: unknown,
): data is MagicLoginEmailResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "securityPhrase" in data &&
    "exchangeToken" in data
  );
}

export function organisationLogoUrl(
  organisation: UrlOrganisation | null | undefined,
): string | undefined {
  return organisation?.darkLogoUrl;
}
